export interface Comic {
  id: string;
  title: string;
  slug: string;
  cover: string;
  description: string;
  author: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  status: "连载中" | "已完结";
  updateDate: string;
  chapters: Chapter[];
  featured?: boolean;
}

export interface Chapter {
  id: number;
  title: string;
  updateDate: string;
}

export const comics: Comic[] = [
  {
    id: "comic-1",
    title: "女神降临",
    slug: "goddess-descend",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20girl%20with%20long%20hair%20in%20school%20uniform%2C%20soft%20pink%20and%20white%20background%2C%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20webtoon%20cover%20art%2C%20delicate%20features%2C%20shojo%20manga%20aesthetic&width=600&height=800&seq=comic-cover-01&orientation=portrait",
    description: "外貌平凡的女生通过化妆技巧变身校园女神，展开了一段关于自信与真爱的青春故事。她能否在真实自我与完美外表之间找到平衡？",
    author: "喵咪",
    category: "romance",
    tags: ["校园", "恋爱", "成长"],
    rating: 9.2,
    views: 1580000,
    status: "连载中",
    updateDate: "2026-08-02",
    chapters: Array.from({ length: 156 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - (i % 4)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
    featured: true,
  },
  {
    id: "comic-2",
    title: "我独自升级",
    slug: "solo-leveling",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20male%20warrior%20with%20dark%20armor%20and%20glowing%20blue%20eyes%2C%20dungeon%20background%20with%20monsters%2C%20action%20packed%20scene%2C%20dark%20moody%20atmosphere%2C%20powerful%20stance%2C%20webtoon%20cover%20art%2C%20dynamic%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait",
    description: "被称为人类最弱兵器的成振宇，在一次双重地下城事件后获得了神秘系统，开始了从最弱到最强的逆袭之路。",
    author: "Chugong",
    category: "action",
    tags: ["系统", "升级", "逆袭"],
    rating: 9.8,
    views: 3200000,
    status: "已完结",
    updateDate: "2026-01-15",
    chapters: Array.from({ length: 179 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2025-${String(12 - Math.floor(i / 15)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
    featured: true,
  },
  {
    id: "comic-3",
    title: "看脸时代",
    slug: "lookism",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20split%20face%20contrast%20between%20handsome%20and%20ugly%20boy%2C%20school%20life%20drama%2C%20society%20commentary%2C%20clean%20illustration%20with%20warm%20lighting%2C%20webtoon%20cover%20art%2C%20emotional%20expression&width=600&height=800&seq=comic-cover-03&orientation=portrait",
    description: "一个被欺凌的胖男孩突然拥有了白天变身为完美帅哥的能力，他的人生从此天翻地覆，也让他开始思考外表与内在的真正意义。",
    author: "朴泰俊",
    category: "drama",
    tags: ["社会", "人性", "双面"],
    rating: 9.5,
    views: 2800000,
    status: "连载中",
    updateDate: "2026-08-03",
    chapters: Array.from({ length: 420 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 53)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
    featured: true,
  },
  {
    id: "comic-4",
    title: "甜蜜的惩罚",
    slug: "sweet-punishment",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romantic%20scene%20with%20couple%20in%20elegant%20attire%2C%20soft%20golden%20lighting%2C%20warm%20pink%20tones%2C%20intimate%20atmosphere%2C%20clean%20webtoon%20illustration%20style%2C%20rose%20petals%2C%20luxury%20setting&width=600&height=800&seq=comic-cover-04&orientation=portrait",
    description: "为了偿还家族债务被迫嫁给冷酷总裁，本以为是地狱般的婚姻，却意外发现了隐藏在冷漠外表下的温柔真心。",
    author: "糖果",
    category: "romance",
    tags: ["总裁", "契约", "先婚后爱"],
    rating: 9.0,
    views: 1250000,
    status: "连载中",
    updateDate: "2026-08-04",
    chapters: Array.from({ length: 89 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 22)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-5",
    title: "狂野之血",
    slug: "wild-blood",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fierce%20warrior%20in%20battle%20stance%2C%20blood%20red%20background%2C%20action%20scene%20with%20sword%2C%20dark%20and%20intense%20mood%2C%20webtoon%20cover%20art%2C%20muscular%20male%20lead%2C%20dynamic%20angle&width=600&height=800&seq=comic-cover-05&orientation=portrait",
    description: "在血族与人类的永恒战争中，一位拥有稀有血统的半血族少年踏上了改变世界格局的征程。",
    author: "血刃",
    category: "action",
    tags: ["血族", "战斗", "超能力"],
    rating: 8.9,
    views: 980000,
    status: "连载中",
    updateDate: "2026-07-28",
    chapters: Array.from({ length: 134 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(7 - Math.floor(i / 26)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-6",
    title: "恶魔的契约",
    slug: "devil-contract",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20mysterious%20demon%20with%20red%20eyes%20and%20dark%20suit%2C%20contract%20paper%20with%20flames%2C%20dark%20gothic%20atmosphere%2C%20supernatural%20theme%2C%20webtoon%20cover%20art%2C%20intricate%20details&width=600&height=800&seq=comic-cover-06&orientation=portrait",
    description: "普通高中生意外与恶魔签订契约，获得了超乎想象的力量，但代价是必须完成99个不可能的委托任务。",
    author: "暗夜",
    category: "fantasy",
    tags: ["恶魔", "契约", "校园"],
    rating: 9.1,
    views: 1120000,
    status: "连载中",
    updateDate: "2026-08-01",
    chapters: Array.from({ length: 112 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 28)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-7",
    title: "秘密花园",
    slug: "secret-garden",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20beautiful%20garden%20scene%20with%20flowers%2C%20female%20lead%20in%20white%20dress%2C%20soft%20pastel%20colors%2C%20romantic%20and%20dreamy%20atmosphere%2C%20webtoon%20cover%20art%2C%20enchanting%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait",
    description: "搬进古老庄园的少女发现了一扇通往神秘花园的门，在那里她遇见了一个被时光遗忘的精灵王子。",
    author: "花月",
    category: "fantasy",
    tags: ["精灵", "时空", "治愈"],
    rating: 9.3,
    views: 890000,
    status: "已完结",
    updateDate: "2026-03-20",
    chapters: Array.from({ length: 95 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2025-${String(12 - Math.floor(i / 8)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-8",
    title: "时间停止",
    slug: "time-stop",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20clock%20and%20time%20theme%2C%20mysterious%20atmosphere%2C%20male%20protagonist%20in%20police%20uniform%2C%20suspenseful%20dark%20blue%20tones%2C%20webtoon%20cover%20art%2C%20crime%20scene%20elements&width=600&height=800&seq=comic-cover-08&orientation=portrait",
    description: "拥有让时间停止能力的刑警，利用这一能力破解连环杀人案件。然而每次使用能力都会消耗他的寿命，他必须在正义与生命之间做出选择。",
    author: "时钟",
    category: "mystery",
    tags: ["推理", "超能力", "刑侦"],
    rating: 9.4,
    views: 1450000,
    status: "连载中",
    updateDate: "2026-07-30",
    chapters: Array.from({ length: 78 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(7 - Math.floor(i / 19)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-9",
    title: "我的野蛮王妃",
    slug: "wild-princess",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20palace%20setting%2C%20princess%20in%20elegant%20hanbok%2C%20warm%20gold%20and%20red%20tones%2C%20historical%20romance%2C%20webtoon%20cover%20art%2C%20beautiful%20traditional%20elements&width=600&height=800&seq=comic-cover-09&orientation=portrait",
    description: "现代女高中生穿越到古代王国，意外成为蛮横公主的贴身侍女，展开了一段跨越时空的爆笑宫廷生活。",
    author: "宫廷风",
    category: "comedy",
    tags: ["穿越", "宫廷", "搞笑"],
    rating: 9.0,
    views: 1100000,
    status: "已完结",
    updateDate: "2025-11-30",
    chapters: Array.from({ length: 120 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2025-${String(11 - Math.floor(i / 10)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-10",
    title: "剑与魔法",
    slug: "sword-magic",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20world%20with%20knight%20holding%20sword%20and%20magic%20circle%2C%20epic%20adventure%2C%20medieval%20setting%2C%20dragon%20in%20background%2C%20webtoon%20cover%20art%2C%20vibrant%20colors&width=600&height=800&seq=comic-cover-10&orientation=portrait",
    description: "平凡少年在异世界中获得了传说中的剑与魔法双重天赋，与伙伴们一起踏上征服魔王城的冒险之旅。",
    author: "异世界",
    category: "fantasy",
    tags: ["异世界", "冒险", "魔法"],
    rating: 8.8,
    views: 1350000,
    status: "连载中",
    updateDate: "2026-08-02",
    chapters: Array.from({ length: 198 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 49)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-11",
    title: "放学后的秘密",
    slug: "after-school-secret",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20comedy%2C%20group%20of%20students%20laughing%20in%20classroom%2C%20bright%20and%20cheerful%20colors%2C%20webtoon%20cover%20art%2C%20youthful%20energy%2C%20slice%20of%20life&width=600&height=800&seq=comic-cover-11&orientation=portrait",
    description: "四个性格迥异的高中生组成了放学后秘密社团，一起体验各种奇妙冒险的青春搞笑日常。",
    author: "青春社",
    category: "comedy",
    tags: ["校园", "日常", "友情"],
    rating: 8.7,
    views: 750000,
    status: "连载中",
    updateDate: "2026-08-03",
    chapters: Array.from({ length: 67 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 16)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-12",
    title: "皇室的私生子",
    slug: "royal-bastard",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20palace%20intrigue%2C%20young%20man%20in%20noble%20attire%2C%20dramatic%20lighting%2C%20political%20tension%2C%20webtoon%20cover%20art%2C%20rich%20dark%20colors&width=600&height=800&seq=comic-cover-12&orientation=portrait",
    description: "被秘密抚养长大的皇室私生子在成年后得知自己的真实身份，卷入了一场关于皇位继承的残酷权力斗争。",
    author: "皇室秘闻",
    category: "drama",
    tags: ["皇室", "权力", "复仇"],
    rating: 9.3,
    views: 1680000,
    status: "连载中",
    updateDate: "2026-07-29",
    chapters: Array.from({ length: 145 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(7 - Math.floor(i / 29)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-13",
    title: "深渊之眼",
    slug: "abyss-eye",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20dark%20horror%20theme%2C%20mysterious%20eye%20motif%2C%20shadowy%20figure%2C%20deep%20purple%20and%20black%20tones%2C%20psychological%20thriller%2C%20webtoon%20cover%20art%2C%20eerie%20atmosphere&width=600&height=800&seq=comic-cover-13&orientation=portrait",
    description: "一名心理医生接手了一个声称能看到他人死亡日期的特殊病人，随着治疗的深入，医生发现自己也被卷入了不可名状的恐怖之中。",
    author: "深渊",
    category: "mystery",
    tags: ["心理", "恐怖", "超自然"],
    rating: 9.1,
    views: 920000,
    status: "连载中",
    updateDate: "2026-08-04",
    chapters: Array.from({ length: 56 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 14)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-14",
    title: "甜蜜家园",
    slug: "sweet-home",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalypse%20survival%2C%20group%20of%20survivors%20in%20building%2C%20monster%20transformation%2C%20dark%20and%20tense%2C%20webtoon%20cover%20art%2C%20gritty%20style&width=600&height=800&seq=comic-cover-14&orientation=portrait",
    description: "在世界突然爆发怪物化的末日危机中，一栋公寓楼的居民们团结起来，在绝望中守护彼此，寻找生存的希望。",
    author: "金坎比",
    category: "fantasy",
    tags: ["末世", "生存", "人性"],
    rating: 9.6,
    views: 2100000,
    status: "已完结",
    updateDate: "2025-06-15",
    chapters: Array.from({ length: 140 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2025-${String(6 - Math.floor(i / 23)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
    featured: true,
  },
  {
    id: "comic-15",
    title: "青春选择题",
    slug: "youth-choice",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20high%20school%20romance%2C%20love%20triangle%2C%20cherry%20blossom%20background%2C%20youthful%20and%20fresh%20colors%2C%20webtoon%20cover%20art%2C%20emotional%20moments&width=600&height=800&seq=comic-cover-15&orientation=portrait",
    description: "高中最后一个学期，女主角面对两个截然不同的男生的追求——青梅竹马的温柔学弟和充满魅力的转校生，她该如何选择？",
    author: "青春纪",
    category: "romance",
    tags: ["校园", "三角恋", "青春"],
    rating: 8.6,
    views: 680000,
    status: "连载中",
    updateDate: "2026-08-01",
    chapters: Array.from({ length: 48 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 12)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-16",
    title: "最强王者",
    slug: "strongest-king",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20fighter%20in%20dynamic%20pose%2C%20energy%20aura%2C%20fist%20glowing%2C%20intense%20action%2C%20webtoon%20cover%20art%2C%20powerful%20composition&width=600&height=800&seq=comic-cover-16&orientation=portrait",
    description: "被废掉武功的昔日最强武者重生回到少年时代，凭借前世的记忆和战斗经验，重新踏上武道巅峰的征途。",
    author: "武极",
    category: "action",
    tags: ["重生", "武道", "逆袭"],
    rating: 9.4,
    views: 1950000,
    status: "连载中",
    updateDate: "2026-08-03",
    chapters: Array.from({ length: 210 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 52)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
    featured: true,
  },
  {
    id: "comic-17",
    title: "幽灵医生",
    slug: "ghost-doctor",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20hospital%20setting%2C%20doctor%20with%20ghostly%20apparition%2C%20medical%20mystery%2C%20cool%20blue%20lighting%2C%20webtoon%20cover%20art%2C%20supernatural%20medical%20drama&width=600&height=800&seq=comic-cover-17&orientation=portrait",
    description: "天才外科医生在车祸后灵魂出窍，附身在一个菜鸟医生身上，两位截然不同的灵魂共用一具身体，在医院中展开奇妙的医疗之旅。",
    author: "医魂",
    category: "mystery",
    tags: ["医疗", "灵魂", "双主角"],
    rating: 9.0,
    views: 1080000,
    status: "连载中",
    updateDate: "2026-07-31",
    chapters: Array.from({ length: 88 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(7 - Math.floor(i / 22)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-18",
    title: "女神的后宫",
    slug: "goddess-harem",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20handsome%20male%20lead%20surrounded%20by%20beautiful%20women%2C%20fantasy%20world%2C%20light%20comedy%20style%2C%20webtoon%20cover%20art%2C%20colorful%20and%20vibrant&width=600&height=800&seq=comic-cover-18&orientation=portrait",
    description: "普通大学生穿越到女尊世界的奇幻大陆，凭借现代知识周旋于各路女神之间，展开一段令人捧腹又热血的后宫冒险。",
    author: "后宫王",
    category: "harem",
    tags: ["穿越", "后宫", "冒险"],
    rating: 8.5,
    views: 1230000,
    status: "连载中",
    updateDate: "2026-08-04",
    chapters: Array.from({ length: 165 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 41)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-19",
    title: "咖啡店恋人",
    slug: "cafe-lovers",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20cozy%20cafe%20setting%2C%20barista%20couple%2C%20warm%20coffee%20tones%2C%20romantic%20slice%20of%20life%2C%20webtoon%20cover%20art%2C%20comforting%20atmosphere&width=600&height=800&seq=comic-cover-19&orientation=portrait",
    description: "在街角咖啡店打工的两个年轻人，用一杯杯咖啡串联起彼此的心情与故事，在香气氤氲中慢慢靠近的心。",
    author: "咖啡因",
    category: "romance",
    tags: ["治愈", "日常", "美食"],
    rating: 8.8,
    views: 560000,
    status: "已完结",
    updateDate: "2025-09-10",
    chapters: Array.from({ length: 72 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2025-${String(9 - Math.floor(i / 8)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
  },
  {
    id: "comic-20",
    title: "无限世界",
    slug: "infinite-world",
    cover: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20multiple%20dimensions%20concept%2C%20hero%20jumping%20between%20worlds%2C%20sci%20fi%20fantasy%2C%20cosmic%20background%2C%20webtoon%20cover%20art%2C%20epic%20scale&width=600&height=800&seq=comic-cover-20&orientation=portrait",
    description: "在无限流世界中，每一层都是一个全新的宇宙。主角必须不断完成挑战任务，收集神器，突破层层世界的限制，寻找回家的路。",
    author: "无限",
    category: "fantasy",
    tags: ["无限流", "穿越", "系统"],
    rating: 9.2,
    views: 1780000,
    status: "连载中",
    updateDate: "2026-08-02",
    chapters: Array.from({ length: 230 }, (_, i) => ({ id: i + 1, title: `第${i + 1}话`, updateDate: `2026-${String(8 - Math.floor(i / 57)).padStart(2, "0")}-${String(1 + (i % 28)).padStart(2, "0")}` })),
    featured: true,
  },
];

export const getComicsByCategory = (category: string): Comic[] => {
  if (category === "all") return comics;
  if (category === "hot") return [...comics].sort((a, b) => b.views - a.views).slice(0, 12);
  return comics.filter((c) => c.category === category);
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter((c) => c.featured);
};

export const getLatestUpdates = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()).slice(0, limit);
};

export const getComicById = (id: string): Comic | undefined => {
  return comics.find((c) => c.id === id);
};

export const getRelatedComics = (comic: Comic, limit: number = 6): Comic[] => {
  return comics.filter((c) => c.category === comic.category && c.id !== comic.id).slice(0, limit);
};